import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { FluentProvider, Theme, teamsDarkTheme, teamsLightTheme } from "@fluentui/react-components";

/* global Office */
interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [isDarkTheme, setIsDarkTheme] = useState(true);

  const toggleTheme = () => {
    setIsDarkTheme(!isDarkTheme);
  };

  useEffect(() => {
    Office.onReady(() => {
      if (Office.context.officeTheme) {
        const isOfficeInDarkTheme = Office.context.officeTheme.bodyBackgroundColor !== "#FFFFFF";
        setIsDarkTheme(isOfficeInDarkTheme);
      }
    });
  }, []);

  const theme = isDarkTheme ? teamsDarkTheme : teamsLightTheme;

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <FluentProvider theme={theme} style={{ height: "100%", overflow: "auto" }}>
        {children}
      </FluentProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
